import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import useGetPrivacyPolicyApi from "../../../Global/Api/Account/getPrivacyPolicy";
import './index.scss';

export default function Privacy() {
    const { get } = useGetPrivacyPolicyApi();
    const {privacy} = useSelector((state) => state.rootReducer.techsbookSlice);
    useEffect(() => {
        get();
    }, [])
  return (
      <div className='privacy-container'>
          <div
              dangerouslySetInnerHTML={{ __html: privacy?.body }}
          />
      </div>
  );
}
